/**
 * 用户统计信息
 */
const UserStats = {
  state: {
    shipmentCount: 0,
    entrepotCount: 0,
    // 添加时间戳字段，记录最后更新时间
    shipmentLastUpdated: 0, 
    entrepotLastUpdated: 0
  },
  mutations: {
    // 更新发货数量
    SET_SHIPMENT_COUNT(state, count) {
      state.shipmentCount = count;
    },
    // 更新仓库数量
    SET_ENTREPOT_COUNT(state, count) {
      state.entrepotCount = count;
    },
    // 添加更新时间戳的 mutation
    SET_SHIPMENT_LAST_UPDATED(state) {
      state.shipmentLastUpdated = Date.now(); // 记录当前时间戳
    },
    SET_ENTREPOT_LAST_UPDATED(state) {
      state.entrepotLastUpdated = Date.now();
    }    
  },
  actions: {
    // 更新发货数量（支持异步操作，如 API 请求后更新）
    updateShipmentCount({ commit }, count) {
      // 可在此处添加校验、日志等逻辑
      commit('SET_SHIPMENT_COUNT', count);
      // 更新数量时同步更新时间戳
      commit('SET_SHIPMENT_LAST_UPDATED'); 
    },
    // 更新仓库数量（支持异步操作，如 API 请求后更新）
    updateEntrepotCount({ commit }, count) {
      // 可在此处添加校验、日志等逻辑
      commit('SET_ENTREPOT_COUNT', count);
      // 更新数量时同步更新时间戳
      commit('SET_ENTREPOT_LAST_UPDATED'); 
    },
  }
  
}

export default UserStats